import React from 'react';
import { useTranslation } from 'react-i18next';

const STORAGE_KEY = 'aiCompareConsentGiven';

export function hasAIConsent(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setAIConsent(): void {
  try {
    localStorage.setItem(STORAGE_KEY, 'true');
  } catch {
    /* ignore */
  }
}

export interface AIConsentDialogProps {
  open: boolean;
  onAgree: () => void;
  onCancel: () => void;
}

const AIConsentDialog: React.FC<AIConsentDialogProps> = ({ open, onAgree, onCancel }) => {
  const { t, i18n } = useTranslation();
  if (!open) return null;

  const isRtl = i18n.language === 'he';
  const dir = isRtl ? 'rtl' : 'ltr';

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 overflow-y-auto"
      role="dialog"
      aria-modal="true"
      aria-labelledby="ai-consent-title"
    >
      <div
        className="bg-white rounded-2xl shadow-xl max-w-md w-full overflow-hidden my-4"
        style={{ direction: dir }}
      >
        <div className="px-5 pt-5 pb-4" dir={dir}>
          <h2 id="ai-consent-title" className="text-lg font-bold text-gray-900 mb-3">
            {t('ai_consent_title')}
          </h2>
          <div className="space-y-3 text-sm text-gray-700">
            <p>{t('ai_consent_p1')}</p>
            <p>{t('ai_consent_p2')}</p>
            <p>{t('ai_consent_p3')}</p>
          </div>
        </div>
        <div className="px-5 pb-5 pt-2 flex gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 py-3 px-4 rounded-xl font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 transition"
          >
            {t('ai_consent_cancel')}
          </button>
          <button
            type="button"
            onClick={onAgree}
            className="flex-1 py-3 px-4 rounded-xl font-semibold text-white transition hover:opacity-90"
            style={{ backgroundColor: '#3B7BF4' }}
          >
            {t('ai_consent_agree')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AIConsentDialog;
